import React, {Component} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {withRouter, matchPath} from 'react-router-dom';
import Spinner from '../Spinner';
import {getNextStep} from '../../actions/getNextStep';
import {getSpecificStep} from '../../actions/getSpecificStep';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';
import {pathnames as P} from '../../constants/pathnames';
import {errors as E} from '../../constants/errors';

function withNextStep(WrappedComponent) {
  return class extends Component {
    componentDidMount() {
      this.checkStepAndRedirect();
      this.checkGoBackAndRedirect();
    }

    componentDidUpdate() {
      this.checkStepAndRedirect();
      this.checkGoBackAndRedirect();
    }

    checkGoBackAndRedirect() {
      const {goBack, history} = this.props;
      if (goBack) {
        history.push(P.HOME);
      }
    }

    checkStepAndRedirect() {
      const {
        location,
        history,
        nextStep,
        nextSpecificStep
      } = this.props;
      const {pathname} = location;
      const match = matchPath(pathname, {
        path: P.STEP_ID,
        exact: false
      });

      const stepId = parseInt(match.params.stepId);

      if (nextSpecificStep !== null && stepId !== nextSpecificStep) {
        history.replace(P.GET_STEP_PATH(nextSpecificStep))
      }
      if (nextSpecificStep === null && nextStep !== null && stepId !== nextStep) {
        history.replace(P.GET_STEP_PATH(nextStep));
      }
    }

    render() {
      const {
        regType,
        nextStep,
        loading,
        goBack,
        error,
        errorMessage,
        getNextStep,
        showGlobalErrorMessage,
        ...rest
      } = this.props;

      if (error) showGlobalErrorMessage(E.COMMON_ERROR);

      if (nextStep === null && !loading && !error) {
        getNextStep(regType, true);
      }

      if (nextStep === 100) return null;

      return (nextStep === null || loading || goBack)
        ? <Spinner/>
        : <WrappedComponent {...rest}/>;
    }
  }
}

const mapStateToProps = ({
                           nextStep: {nextStep, goBack, loading, error, errorMessage},
                           regType: {regType},
                           specificStep
                         }) => {
  const nextSpecificStep = specificStep.nextStep;
  return {
    regType,
    goBack,
    nextStep,
    loading,
    error,
    errorMessage,
    nextSpecificStep
  }
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    {getNextStep, showGlobalErrorMessage, getSpecificStep}
  ),
  withNextStep
);
